import * as $ from "jquery";

export const Languages = (() => {

	const langList = {
		pl: "pl-PL",
		en: "en-GB",
	};

	const currentKey = $("#meta_language").attr("content") || 'pl';
	return {
		langList,
		Current: {
			key: currentKey,
			code: langList[currentKey]
		}
	}
})();

export const getCurrentLanguage = (() => {
	const url = window.location.href;
	const lang = url.toString().split('/')[3];
	return lang;
})();


import * as $ from "jquery";

export const Languages = (() => {

	const langList = {
		pl: "pl-PL",
		en: "en-GB",
	};

	const currentKey = $("#meta_language").attr("content") || 'pl';
	return {
		langList,
		Current: {
			key: currentKey,
			code: langList[currentKey]
		}
	}
})();

export const getCurrentLanguage = (() => {
	const url = window.location.href;
	const lang = url.toString().split('/')[3];
	return lang;
})();


